import { render, staticRenderFns } from "./ActivityDeleteDialog.vue?vue&type=template&id=54dc0696"
import script from "./ActivityDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ActivityDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports